import { on } from 'delegated-events'
import debounce from 'lodash/debounce'

const $header = document.querySelector('.site-header')

const state = {
  headerHeight: 0,
  stuck: true,
}

const fn = {
  init: () => {
    state.headerHeight = $header.offsetHeight

    fn.handleScroll()
    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('scroll', fn.handleScroll)
    window.addEventListener('resize', debounce(fn.handleResize, 250))
    on('click', '.site-nav-trigger', fn.toggleNav)
  },

  handleScroll: () => {
    state.stuck = window.pageYOffset > 1
    $header.classList.toggle('is-stuck', state.stuck)
  },

  handleResize: () => {
    state.headerHeight = $header.offsetHeight
  },

  toggleNav: () => {
    document.documentElement.classList.toggle('js-nav-active')
  },
}

export default {
  can: () => document.contains($header),
  run: fn.init,
}
